import { message } from 'antd'
import _ from 'lodash'
import qs from 'qs'

import { ICaptchaImageResult } from '../components/captchaImage/const'
import { ICaptchaSliderResult } from '../components/captchaSlider/const'
import encrypt from './encrypt'
import { getLogin } from '../service'

const getHashQuery = () => {
  if(!window.location.hash) return {}
  const firstSignIndex = window.location.hash.indexOf('?')
  if(firstSignIndex < 0) return {}
  const queryStr = window.location.hash.substr(firstSignIndex + 1)
  if(!queryStr) return {}
  return qs.parse(queryStr)
}

const isDev = process.env.NODE_ENV === 'development'
// 跳转主页面
export const goIndex = (): void => {
  const gobackUrl = getHashQuery().back
  console.trace(getHashQuery(), gobackUrl)
  window.location.href = isDev ? `/#${gobackUrl || '/home'}` : `./index.html#${gobackUrl || '/home'}`
}

/**
 * 获取登录请求参数
 * @param isSlider 是否为滑块验证方式
 * @param account 帐号
 * @param password 密码
 * @param imageCode 验证码
 * @param slider 滑块验证信息
 */
const getLoginRequestParams = (
  isSlider,
  account,
  password,
  imageCode: ICaptchaImageResult|null|undefined,
  slider: ICaptchaSliderResult|null|undefined,
  adminQRCodeLoginToken:string|undefined
) => {
  const { slideChallenge, slideSecCode, slideValidate } = slider || {}
  const { captchaCode } = imageCode || {}
  // 公共参数
  const commonParams = {
    userNum: account,
    password: encrypt(password),
  }
  const params = isSlider ? {
    ...commonParams,
    isSlideValidate: 'true',
    slideChallenge,
    slideSecCode,
    slideValidate,
    type: '101',
    enterpriseId: '',
    enterpriseName: ''
  } : {
    ...commonParams,
    adminQRCodeLoginToken,
    validate: captchaCode ? captchaCode.toLocaleUpperCase() : 'ZN19'
  }

  // 帐号或者密码为空
  if (account.length === 0 || password.length === 0) {
    message.error('帐号或密码不能为空')
    return false
  }
  // 滑块验证，滑块信息为空
  if (isSlider && !slideChallenge) {
    message.error('请完成验证')
    return false
  }
  // 图片验证，图片验证码为空
  // if (!isSlider && (captchaCode || '').trim().length === 0) {
  //   message.error('验证码不能为空')
  //   return false
  // }
  return params
}

interface IFetchLoginParams {
  captchaType?: 0|1|null
  account?: string|null
  password?: string|null
  imageCode?: ICaptchaImageResult|null
  slider?: ICaptchaSliderResult|null
  changeCaptchaToImage?: () => any |null,
  adminQRCodeLoginToken?:string|any|null,
  cb?: () => void
}

// 重置验证组件
const resetCaptcha = (slider: ICaptchaSliderResult|null|undefined, imageCode: ICaptchaImageResult|null|undefined) => {
  if (slider) {
    slider.reset()
  } else if (imageCode) {
    imageCode.reset()
  }
}

/**
 * 发送登录请求
 * @param captchaType 验证类型(0: 图片验证码; 1: 滑块验证码;)
 * @param account 帐号
 * @param password 密码
 * @param imageCode 图片验证码
 * @param slider 滑块验证信息
 * @param changeCaptchaToImage 切换为图片验证码
 */
export const fetchLogin = async ({
  captchaType,
  account,
  password,
  imageCode,
  slider,
  changeCaptchaToImage,
  adminQRCodeLoginToken
}: IFetchLoginParams, chooseEnterprise?: (enterpriceList: any[]) => Promise<string>) => {
  let params:any = null
  if (adminQRCodeLoginToken) {
    params = { adminQRCodeLoginToken, userNum: '101' }
  } else {
    params = getLoginRequestParams(captchaType === 1, account, password, imageCode, slider, adminQRCodeLoginToken)
  }

  // 登录
  const result = await getLogin(params)
  const { code, msg, data } = result
  // 单企业，直接登录成功
  if (+code === 200) {
    localStorage.setItem('loginUserNum', params.userNum)
    localStorage.setItem('loginAreaCodeIndex', '86')
    message.success('登录成功')
    goIndex()
    return
  }
  // 多企业， 选择企业列表
  if (code === '-7' || code === '0') {
    let orgId = data[0].enterpriseId
    if (chooseEnterprise) {
      orgId = await chooseEnterprise(data)
    }
    getLogin({
      userNum: account,
      password,
      enterpriseId: orgId,
      validate: 'ZN19'
    }).then(() => {
      goIndex()
    })
    return
  }
  if (code === '1') {
    setTimeout(() => {
      goIndex()
    }, 1000)
  } else if (Number(code) === 200) {
    // 登录成功
    // localStorage.setItem('loginUserNum', params.userNum)
    // localStorage.setItem('loginAreaCodeIndex', '86')
    // message.success('登录成功')
    // goIndex()
  } else if (code === '2') {
    if (adminQRCodeLoginToken) {
      // eslint-disable-next-line no-console
      console.log(adminQRCodeLoginToken)
    } else {
      // 登录报错
      message.error(msg)
      resetCaptcha(slider, imageCode)
    }
  } else if (code === '100') {
    if (changeCaptchaToImage) {
      changeCaptchaToImage()
    }
  } else if (code === '3') {
    message.error(msg)
    resetCaptcha(slider, imageCode)
  } else {
    message.error(msg)
    resetCaptcha(slider, imageCode)
  }
}

/**
 * 是否允许登录
 * @param captchaType 验证类型(0: 图片验证码; 1: 滑块验证码;)
 * @param account
 * @param password
 * @param slider
 * @param captchaCode
 */

export const isAbleLogin = (
  captchaType: 0|1,
  account: string,
  password: string,
  slider: ICaptchaSliderResult | null,
  // captchaCode: ICaptchaImageResult | null,
) => {
  if (!account || !password) {
    return false
  }
  if (captchaType === 1) {
    return !!slider
  }
  return true
  // return !!captchaCode && captchaCode.captchaCode.length >= 4
}

/**
 * 防抖
 */
export const changeAccount = _.debounce((func: () => any) => {
  func()
}, 400, {
  leading: true,
  trailing: true
})
